var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "flex-between-center w-100",
      class: {
        "mob-flex-column  mob-flex-start-start": _vm.mode !== "edenred",
      },
    },
    [
      _vm.title ? _c("div", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "payGreen flex-start-center gap-2 flex-wrap",
          class: { "py-5 mob-mt-5": _vm.mode !== "edenred" },
        },
        [
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.TRD) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "Bimpli",
                  src: "dist/assets/payment/titre-bimpli.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.TRD) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "UP Déjeuner",
                  src: "dist/assets/payment/titre-up.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.TRD) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "Pluxee - Sodexo",
                  src: "dist/assets/payment/titre-pluxee.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.RESTOFLASH) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "Restoflash",
                  src: "dist/assets/payment/titre-restoflash.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.CVD) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "ANCV Connect",
                  src: "dist/assets/payment/titre-ancv.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive(_vm.PAY_GREEN_PAYMENT_TYPE.LUNCHR) &&
          _vm.CheckoutService.canConfirmByPayGreen(_vm.order)
            ? _c("img", {
                staticClass: "size-h-25 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "ANCV Connect",
                  src: "dist/assets/payment/titre-swile.svg",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isActive("edenred") &&
          _vm.CheckoutService.canConfirmByEdenred(_vm.order)
            ? _c("img", {
                staticClass: "size-h-30 bg-white border-grey7 p-5 radius-4",
                attrs: {
                  title: "Edenred",
                  src: "dist/assets/payment/ticket-edenred.svg",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("goto-edenred")
                  },
                },
              })
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }